const config = {
    version:{
        spaceXApi: "v4"
    },
    api: {
        spaceXApi: "https://api.spacexdata.com"
    }
}

export default config